import { type ReactNode, useEffect, useRef } from "react";

import CsspSuppliersContext from "./CsspSuppliersContext";
import { CsspSuppliersStore } from "./CsspSuppliersStore";

/** Application boundary for the one current-tab supplier availability model. */
export const CsspSuppliersProvider = ({ children }: { children: ReactNode }) => {
  const storeRef = useRef<CsspSuppliersStore | null>(null);
  if (!storeRef.current) storeRef.current = new CsspSuppliersStore();
  useEffect(() => () => storeRef.current?.dispose(), []);
  return <CsspSuppliersContext.Provider value={storeRef.current}>{children}</CsspSuppliersContext.Provider>;
};
